module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "conditional-modal",
      "adaptive": true,
      "max-width": 1000,
      "max-height": 400,
      "width": "80%",
      "height": "50%"
    },
    on: {
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "30px",
      "text-align": "center"
    }
  }, [_vm._v("\n    Hello!\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdcb9232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ConditionalModal.vue
// module id = 39
// module chunks = 0